import { Col, Icon, Row, Text } from 'ui';

type P = {
  payer: {
    apt?: string;
    city: string;
    country: string;
    email: string;
    firstName: string;
    lastName: string;
    state?: string;
    street: string;
    zip: string;
  };
};

const PayerInformation = ({ payer }: P) => (
  <Row gutter={[0, 'xs']}>
    <Col span={24}>
      <Row align="middle" gutter={['ms', 0]}>
        <Col>
          <Text weight="medium">
            <Icon icon="user-1-line" size="medium-small" />
          </Text>
        </Col>
        <Col>
          <Text weight="medium">{`${payer.firstName} ${payer.lastName}`}</Text>
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Row align="middle" gutter={['ms', 0]}>
        <Col>
          <Text weight="medium">
            <Icon icon="mail-line" size="medium-small" />
          </Text>
        </Col>
        <Col>
          <Text weight="medium">{payer.email}</Text>
        </Col>
      </Row>
    </Col>
    <Col span={24}>
      <Row gutter={['ms', 0]}>
        <Col>
          <Text weight="medium">
            <Icon icon="location-line" size="medium-small" />
          </Text>
        </Col>
        <Col>
          <Text weight="medium">
            {payer.street} {payer.apt}
            <br />
            {payer.zip}, {payer.city}
            {payer.state ? `, ${payer.state}` : ''}
            <br />
            {payer.country}
          </Text>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default PayerInformation;
